import React from 'react'
import './login.less'
import { setHeader } from '@/util/set-header'
import { withRouter } from 'react-router'
import { InputItem, Button, Toast } from 'antd-mobile'
import { appLoginApi, sendVerifyApi } from '@/api/sany'
import Cookies from 'universal-cookie'
import md5 from 'md5'
@(withRouter as any)
export default class Login extends React.Component<any, any> {
  state = {
    time: 60,
    phone: '',
    verify: '',
  }
  countDowning = false
  constructor(props: any) {
    super(props)
    this.sendVerify = this.sendVerify.bind(this)
    this.loginClick = this.loginClick.bind(this)
  }

  UNSAFE_componentWillMount() {
    setHeader({ className: 'login-navbar' })
  }

  async sendVerify() {
    if (this.state.phone.length !== 11) {
      Toast.info('请输入正确的手机号~')
      return
    }
    this.countDowning = true
    let count = this.state.time
    const _this = this
    const { data } = await sendVerifyApi({
      phone: this.state.phone,
      type: 'login',
    })
    if (data.code === 'SUCCESS') {
      const timer = setInterval(() => {
        count -= 1
        if (count === 0) {
          _this.countDowning = false
          count = 60
          clearInterval(timer)
        }
        _this.setState({
          time: count,
        })
      }, 1000)
    } else {
      Toast.info(data.msg)
    }
  }

  async loginClick() {
    if (this.state.phone.length !== 11) {
      Toast.info('请输入正确的手机号~')
      return
    }
    if (this.state.verify.length !== 6) {
      Toast.info('请输入正确的验证码~')
      return
    }
    const { data } = await appLoginApi({
      phone: this.state.phone,
      verify: this.state.verify,
    })
    if (data.code === 'SUCCESS') {
      const cookie = new Cookies()
      cookie.set('sany_phone', this.state.phone)
      const key = md5(process.env.REACT_APP_MD5_KEY + this.state.phone.trim())
      cookie.set('sany_phone_app_sign', key)
      // cookie.set('sany_phone', '15868194226')
      // cookie.set('sany_communityId', '12151165')
      this.props.history.push({ pathname: '/sany/dorm-list' })
    } else {
      Toast.info(data.msg)
    }
  }

  phoneChange(v: string) {
    this.setState({
      phone: v,
    })
  }

  verifyChange(v: string) {
    this.setState({
      verify: v,
    })
  }

  render() {
    return (
      <div className="login">
        <div className="login-content">
          <div className="login-font">登录</div>
          <div className="login-phone">
            <InputItem
              clear
              value={this.state.phone}
              onChange={(v) => this.phoneChange(v)}
              placeholder="请输入手机号"
            >
              <div
                style={{
                  backgroundImage: 'url(/public/assets/img/phone.png)',
                  backgroundSize: 'cover',
                  height: '22px',
                  width: '22px',
                }}
              />
            </InputItem>
          </div>
          <div className="login-verify">
            <div className="input-class">
              <InputItem
                clear
                value={this.state.verify}
                onChange={(v) => this.verifyChange(v)}
                placeholder="请输入验证码"
                style={{ width: '100%' }}
              >
                <div
                  style={{
                    backgroundImage: 'url(/public/assets/img/lock.png)',
                    backgroundSize: 'cover',
                    height: '22px',
                    width: '22px',
                  }}
                />
              </InputItem>
            </div>
            <Button
              type="warning"
              size="small"
              disabled={this.countDowning}
              style={{ width: '30%' }}
              onClick={this.sendVerify}
            >
              {this.countDowning ? this.state.time : '验证码'}
            </Button>
          </div>
          <Button
            className="login-btn"
            type="warning"
            onClick={this.loginClick}
          >
            登录
          </Button>
        </div>
      </div>
    )
  }
}
